// Generated by CoffeeScript 2.7.0
var DateTime;

import Base from './base.js';

export default DateTime = class DateTime extends Base {
  static resolveTypedAttributes(attributes, specified_attributes, _from_field_type) {
    attributes.settings.input_type = specified_attributes && specified_attributes.input_type || 'datetime-local';
    return attributes;
  }

};
